export default "__VITE_ASSET__B_yKOb7l__"